import type { SVGProps } from 'react';

const SvgChannelAffinity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="channel-affinity"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill={props.color}
      d="M26.61 14.77c-.37 0-.72-.22-.87-.56l-1-2.13a.5.5 0 0 0-.24-.24l-2.14-1c-.33-.15-.55-.5-.55-.87s.22-.72.56-.87l2.13-.99c.11-.05.19-.14.24-.24l1-2.14a.959.959 0 0 1 1.74.01l1 2.13c.05.11.14.19.24.24l2.14 1c.33.15.55.5.55.87s-.22.72-.56.87l-2.13 1c-.11.05-.19.14-.24.24l-1 2.14c-.16.34-.5.55-.87.55Zm-2.57-4.8 1.09.51c.43.2.77.54.97.97l.51 1.09.51-1.09c.2-.43.54-.77.97-.97l1.09-.51-1.09-.51c-.43-.2-.77-.54-.97-.97l-.51-1.09-.51 1.09c-.2.43-.54.77-.97.97zm3.06-3.62"
    />
    <path
      fill={props.color}
      d="M30.68 30.06V18.74c0-1.52-1.23-2.75-2.75-2.75h-2.64c-1.52 0-2.75 1.23-2.75 2.75v11.32h-2.47V3.7c0-1.52-1.23-2.75-2.75-2.75h-2.64c-1.52 0-2.75 1.23-2.75 2.75v26.35H8.98V12.78c0-1.52-1.23-2.75-2.75-2.75H3.59c-1.52 0-2.75 1.23-2.75 2.75v18.78h30.3v-1.5h-.47Zm-6.64-11.32c0-.69.56-1.25 1.25-1.25h2.64c.69 0 1.25.56 1.25 1.25v11.32h-5.14zM13.44 3.7c0-.69.56-1.25 1.25-1.25h2.64c.69 0 1.25.56 1.25 1.25v26.35h-5.14zM2.35 12.78c0-.69.56-1.25 1.25-1.25h2.64c.69 0 1.25.56 1.25 1.25v17.28H2.35z"
    />
  </svg>
);

export default SvgChannelAffinity;
